module.exports = __webpack_public_path__ + "img/common-file-upload.1d315923.svg";